import React, { useState, useEffect, useContext } from "react";
import Slider from "react-slick";
import Header from "./Header";

import Footer from "./Footer";

import sliderdecore from '../assets/images/slider-decore.svg';
import workpremium from '../assets/images/icons/work-premium.svg';
import reporting from '../assets/images/icons/reporting-icon.svg';
import bannerfounders from '../assets/images/founders2.png';
import learningIcon from '../assets/images/icons/learning-icon.svg';
import livecpc from '../assets/images/live-cpc.svg';

import { contentContext } from "../context/contentContext";
import tmdbApi from "../api/tmdbApi";

import whychooseus from '../assets/images/why-choose-us-left.png';
import whychooseusright from '../assets/images/why-choose-us-right.png';
import dermatologists from '../assets/images/dermatologists.svg';
import experienceexperts from '../assets/images/experience-experts-icon.svg';
import labreporticon from '../assets/images/lab-report-icon.svg';
import responsiveicon from '../assets/images/responsive-icon.svg';

import heroright from '../assets/images/hero-right.svg';
import check_circle from '../assets/images/icons/check_circle.svg';
import experts from '../assets/images/experts.svg';

import advanced from '../assets/images/advanced.svg';
import Founder1 from '../assets/images/Founder-1.png';
import Founder2 from '../assets/images/Founder-2.png';
import Founder3 from '../assets/images/Founder-3.png';
// import Founder3 from '../assets/images/hero-bg.jpg';
import { useNavigate, Link } from "react-router-dom";
import heroBox from '../assets/images/hero-box.png';
import heroBox1 from '../assets/images/hero-box1.png';

import CPCBlock from "./quiz/CPCBlock";

const Home = () => {
    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const navigate = useNavigate();

const {
    searchedFlag,
    setSearchedFlag,
    isLoading,
    setIsLoading,
    processObject,
    sortTableAlpha,
    arrow,
    sortTableByDate,
    userData,
    companysearch,
    setCompanySearch,
    companyadvSearch,
    setCompanyAdvSearch,
    currentPage,
    setcurrentPage,
    data,
    setData,
    rowsPerPage,
    setRowsPerPage,
    currentPageNew,
    setCurrentPage,
    route,
    setRoute,
    usePrevious,
    setActiveMenuId,
    setActiveMenuObj,
    GetTimeActivity
} = useContext(contentContext);
    const token = localStorage.getItem("token")
    const [quizInfo, setQuizInfo] = useState(null)
    const [isEnabled, setIsEnabled] = useState(false);



    const getCpcInfo = async () => {
        const response = await tmdbApi.cpcInfoWithouttoken("RESULT PENDING");
        if (response?.result?.length > 0) {
            setQuizInfo(response?.result[0])
        }
    }

    // useEffect(() => {
    //     if (quizInfo && quizInfo?.scheduleDate && quizInfo?.scheduleStartTime && quizInfo?.scheduleEndTime) {
    //         const checkTime = () => {
    //             const [year, month, day] = quizInfo?.scheduleDate?.split("-").map(Number);
    //             const [startHour, startMinute] = quizInfo?.scheduleStartTime?.split(":").map(Number);
    //             const [endHour, endMinute] = quizInfo?.scheduleEndTime?.split(":").map(Number);

    //             // Build start and end time in IST by creating UTC time from IST offset
    //             const toUtcFromIST = (h, m) => {
    //                 return new Date(Date.UTC(year, month - 1, day, h - 5, m - 30));
    //             };

    //             const startIST = toUtcFromIST(startHour, startMinute);
    //             const endIST = toUtcFromIST(endHour, endMinute);

    //             const nowUTC = new Date();

    //             setIsEnabled(nowUTC >= startIST && nowUTC <= endIST);

    //             const now = new Date();



    //             const [hours, minutes] = quizInfo?.scheduleStartTime.split(":").map(Number);

    //             // Create a new Date from base and set the time (in UTC)
    //             const finalDate = new Date(quizInfo?.scheduleDate);
    //             finalDate.setUTCHours(hours);
    //             finalDate.setUTCMinutes(minutes);
    //             finalDate.setUTCSeconds(0);
    //             finalDate.setUTCMilliseconds(0);


    //             const timeDifference = finalDate - now;

    //             if (timeDifference <= 0) {
    //                 clearInterval(interval);
    //                 setDays(0);
    //                 setHours(0);
    //                 setMinutes(0);
    //                 setSeconds(0);
    //                 return;
    //             }

    //             setDays(Math.floor(timeDifference / (1000 * 60 * 60 * 24)));
    //             setHours(Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    //             setMinutes(Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60)));
    //             setSeconds(Math.floor((timeDifference % (1000 * 60)) / 1000));
    //         };

    //         checkTime(); // Initial check
    //         const interval = setInterval(checkTime, 1000); // Re-check every 1 seconds

    //         return () => clearInterval(interval);
    //     }
    // }, [quizInfo]);




    // Set the date for the event, 25 days from now
    const targetDate = new Date('2025-06-11T00:00:00');

    useEffect(() => {
        window.scrollTo(0, 0);
        getCpcInfo()
    }, []);

    const displayDate = (date) => {
        const formattedDate = new Date(date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        return formattedDate;

    }

    const convertToAMPM = (time24) => {
        const [hour, minute] = time24.split(":").map(Number);
        const date = new Date();
        date.setHours(hour);
        date.setMinutes(minute);

        return date.toLocaleTimeString('en-IN', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        speed: 300,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: true,
    };
    const handelnavigation = () => {
        navigate("/login")

    }

    const handelnavigation3 = () => {
        if (!localStorage.getItem("token")) {
            localStorage.setItem('userType', "CLINICIAN")
            navigate("/signup")
        }


    }
    const handelnavigation4 = () => {

        if (token) {
            navigate("/cpc-student")

        } else {
            localStorage.setItem('userType', "STUDENT")

            navigate("/signup")
        }


    }
 useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
        if (userData?.userType === "DOCTOR") {
            navigate("/cpc");
        } else if (userData?.userType && userData.userType !== "DOCTOR") {
            navigate("/dashboard");
        }
    }
}, [userData]);
    return (
        <>
            <Header />



            {/* <Slider {...settings}> */}
                <section className="hero-section">
                    <div className="slider_decore">
                        <img src={sliderdecore} alt="DADI Logo" width="320" />
                    </div>
                    <img src={heroBox} alt="Reporting" className="rectangle_box" width="494" />
                    <img src={heroBox1} alt="Reporting" className="rectangle_box1" width="400" />
                    <div className="container">
                        <div className="row align-items-center">

                            <div className="col-md-6 z-1 right-text-wrapper hero_left">
                                <h1 className="title">Welcome to DADI</h1>
                                <div className="badge bg-white shadow-sm dadi_badge">
                                    <img src={workpremium} alt="DADI Logo" width="20" />
                                    India’s Premier Virtual Dermatopathology Hub
                                </div>
                                <h3 className="sub_title">Expert Diagnostics |<br /> Cutting-Edge Education</h3>

                                <p className="mt-4 explore_text">Explore</p>
                                <div className="d-flex mt-2 explore">
                                    <div className="card-icon-box text-center">
                                        <img src={reporting} alt="Reporting" className="mb-3" width="44" />
                                        <p className="mb-0">Reporting</p>
                                        <p className="clinicians">For Clinicians</p>
                                    </div>
                                    <div className="card-icon-box text-center">
                                        <img src={learningIcon} alt="Learning" className="mb-3" width="44" />
                                        <p className="mb-0">Learning</p>
                                        <p className="clinicians">for Fellows & Students</p>
                                    </div>
                                </div>
                            </div>


                            <div className="col-md-6 left-img-wrapper">
                                <img src="https://d354x6hy183g4m.cloudfront.net/Dadi/Common/images/founders3.svg" alt="Girl with Microscope" className="hero-girl-img img-fluid" />                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className="hero-section">
                    <div className="slider_decore">
                        <img src={sliderdecore} alt="DADI Logo" width="320" />
                    </div>
                    <img src={heroBox} alt="Reporting" className="rectangle_box" width="494" />
                    <img src={heroBox1} alt="Reporting" className="rectangle_box1" width="400" />
                    <div className="container">
                        <div className="row align-items-center">

                            <div className="col-md-6 z-1 right-text-wrapper hero_left">
                                <h1 className="title">Welcome to DADI</h1>
                                <div className="badge bg-white shadow-sm dadi_badge">
                                    <img src={workpremium} alt="DADI Logo" width="20" />
                                    India’s Premier Virtual Dermatopathology Hub
                                </div>
                                <h3 className="sub_title">Expert Diagnostics |<br /> Cutting-Edge Education</h3>

                                <p className="mt-4 explore_text">Explore</p>
                                <div className="d-flex mt-2 explore">
                                    <div className="card-icon-box text-center">
                                        <img src={reporting} alt="Reporting" className="mb-3" width="44" />
                                        <p className="mb-0">Reporting</p>
                                        <p className="clinicians">For Clinicians</p>
                                    </div>
                                    <div className="card-icon-box text-center">
                                        <img src={learningIcon} alt="Learning" className="mb-3" width="44" />
                                        <p className="mb-0">Learning</p>
                                        <p className="clinicians">for Fellows & Students</p>
                                    </div>
                                </div>
                            </div>


                            <div className="col-md-6 left-img-wrapper">
                                <img src="https://d354x6hy183g4m.cloudfront.net/Dadi/Common/images/founders3.svg" alt="Girl with Microscope" className="hero-girl-img img-fluid" />                            </div>
                        </div>
                    </div>
                </section>
                <section className="hero-section">
                    <div className="slider_decore">
                        <img src={sliderdecore} alt="DADI Logo" width="320" />
                    </div>
                    <img src={heroBox} alt="Reporting" className="rectangle_box" width="494" />
                    <img src={heroBox1} alt="Reporting" className="rectangle_box1" width="400" />
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6 z-1 right-text-wrapper hero_left">
                                <h1 className="title">Welcome to DADI</h1>
                                <div className="badge bg-white shadow-sm dadi_badge">
                                    <img src={workpremium} alt="DADI Logo" width="20" />
                                    India’s Premier Virtual Dermatopathology Hub
                                </div>
                                <h3 className="sub_title">Expert Diagnostics |<br /> Cutting-Edge Education</h3>

                                <p className="mt-4 explore_text">Explore</p>
                                <div className="d-flex mt-2 explore">
                                    <div className="card-icon-box text-center">
                                        <img src={reporting} alt="Reporting" className="mb-3" width="44" />
                                        <p className="mb-0">Reporting</p>
                                        <p className="clinicians">For Clinicians</p>
                                    </div>
                                    <div className="card-icon-box text-center">
                                        <img src={learningIcon} alt="Learning" className="mb-3" width="44" />
                                        <p className="mb-0">Learning</p>
                                        <p className="clinicians">for Fellows & Students</p>
                                    </div>
                                </div>
                            </div>


                            <div className="col-md-6 left-img-wrapper">
                                <img src="https://d354x6hy183g4m.cloudfront.net/Dadi/Common/images/founders3.svg" alt="Girl with Microscope" className="hero-girl-img img-fluid" />                            </div>
                        </div>
                    </div>
                </section> */}
            {/* </Slider> */}
<section className="session-section">
                {/* <div className="" style={{position:'absolute'}}>
                    <img src={sessionbg} alt="DADI Logo" width="1130" />
                </div> */}
                <p className="adv_lrn mb-3">Advanced Learning Hub</p>
              
                <CPCBlock timer={true} />
            </section>
            <section className="services">
                <div className="services-container">
                    <div className="service-card">
                        <img src={experts} alt="DADI Logo" width="100%" />
                        <div className="service_content">
                            <h3>Expert Dermatopathology Diagnostics</h3>
                            <p className="expert_diagnostics">For Dermatologists and Clinicians</p>
                            <p className="submit_yours">Submit your skin biopsy specimens with ease and receive timely, detailed reports from board-certified dermatopathologists.</p>
                            <ul className="service-features">
                                <li className="service-feature">
                                    <img src={check_circle} width="20" alt="Check Icon" />
                                    <p>Fast, secure online submissions</p>
                                </li>
                                <li className="service-feature">
                                    <img src={check_circle} width="20" alt="Check Icon" />
                                    <p>Accurate and insightful diagnostic reports</p>
                                </li>
                                <li className="service-feature">
                                    <img src={check_circle} width="20" alt="Check Icon" />
                                    <p>Clear communication for better patient care</p>
                                </li>
                            </ul>
                        </div>
                        <div className="service-link">
                            <button className="btn-stroke-icon" onClick={(e) => handelnavigation3()}>
                                <span className="material-symbols-outlined btn-icon-stroke-style">keyboard_arrow_right</span>SUBMIT A CASE </button>
                        </div>
                    </div>
                    <div className="service-card">
                        <img src={advanced} alt="DADI Logo" width="100%" />
                        <div className="service_content">
                            <h3>Advanced Learning Hub</h3>
                            <p className="expert_diagnostics">For Learners, Fellows & Dermatopathology Enthusiasts</p>
                            <p className="submit_yours">Explore a wide range of educational resources to build and refine your expertise.</p>
                            <ul className="service-features">
                                <li className="service-feature">
                                    <img src={check_circle} width="20" alt="Check Icon" />
                                    <p>Interactive learning modules</p>
                                </li>
                                <li className="service-feature">
                                    <img src={check_circle} width="20" alt="Check Icon" />
                                    <p>Monthly CPC (Clinicopathologic Correlation) sessions</p>
                                </li>
                                <li className="service-feature">
                                    <img src={check_circle} width="20" alt="Check Icon" />
                                    <p>Comprehensive virtual fellowship program</p>
                                </li>
                            </ul>
                        </div>
                         <div className="service-link">
                            <button className="btn-stroke-icon" onClick={(e) => handelnavigation3()}>
                                <span className="material-symbols-outlined btn-icon-stroke-style">keyboard_arrow_right</span>EXPLORE COURSES </button>
                        </div>
                    </div>
                </div>
            </section>


            <section className="why-choose-us">
                <img src={whychooseus} className="why-choose-us-left" />
                <img src={whychooseusright} className="why-choose-us-right" />
                <div className="container">
                    <div className="left-section">
                        <p className="txt-16">Advanced Learning Hub</p>
                        <h1 className="txt-48">Why Choose Us ?</h1>
                        <p className="txt-26">Delivering diagnostic accuracy and educational excellence—every step of the way.</p>
                        <p className="txt-22">At the intersection of precision diagnostics and advanced education, our platform is built to serve both clinicians and learners. With board-certified dermatopathologists, interactive learning tools, and a seamless digital experience, we empower you to deliver better care and deepen your expertise—anytime, anywhere.</p>
                      <div className="mt-4">
                          <a className="register-link" target="_blank" onClick={(e) => handelnavigation()}>
                            <button className="btn-fill-icon"><span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right</span>Join Us</button>
                        </a>
                      </div>
                    </div>
                    <div className="right-section">
                        <div className="content-right">
                            <div className="card">
                                <div className="icon-area">
                                    <span></span>
                                    <img src={dermatologists} />
                                </div>
                                <p className="txt-20">Trusted by<br />dermatologists<br />worldwide</p>
                            </div>
                            <div className="card">
                                <div className="icon-area">
                                    <span></span>
                                    <img src={experienceexperts} />
                                </div>
                                <p className="txt-20">Led by experienced experts<br />in dermatopathology</p>
                            </div>
                            <div className="card">
                                <div className="icon-area">
                                    <span></span>
                                    <img src={labreporticon} />
                                </div>
                                <p className="txt-20">Designed for both clinical<br />practice and academic<br />growth</p>
                            </div>
                            <div className="card">
                                <div className="icon-area">
                                    <span></span>
                                    <img src={responsiveicon} />
                                </div>
                                <p className="txt-20">Accessible anytime,<br />anywhere</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>




            {/* <section className="founder-section">
                <img src={heroright} className="founder-left" />
                <div className="container">
                    <div className="card-header">
                        <div>
                            <p className="txt-16"><span></span>Our Healthcare Experts</p>
                            <h1 className="txt-48">Meet The Founders</h1>
                        </div>
                        <p className="txt-22">Our platform was founded by a team of experienced dermatopathologists and medical educators with a shared vision-to make expert skin diagnostics accessible and dermatopathology education engaging. modern, and global </p>
                    </div>
                    <div className="founders-grid row mt-4">

                        <div className="col-md-4">
                            <div className="team-card">
                                <img src={Founder1} alt="Lucas Harris" />
                                <div className="info">
                                    <p className="txt-26">Dr.G.Nanda kumar</p>
                                    <p className="txt-22">MD(D&V),MD(Path)</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="team-card">
                                <img src={Founder2} alt="Lucas Harris" />
                                <div className="info">
                                    <p className="txt-26">Dr.Manoj K.Singh</p>
                                    <p className="txt-22">MD,FRCPath</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="team-card">
                                <img src={Founder3} alt="Lucas Harris" />
                                <div className="info">
                                    <p className="txt-26">Dr.Sasi Kiran Attili</p>
                                    <p className="txt-22">MBBS, MRCP (London), CCT (Dermatology, UK), Dip. Dermatopathology (Frankfurt)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <Footer />
        </>
    )
}

export default Home;
